import { RESULT_INSUFFICIENT_REASON_LABEL } from 'src/features/proofs/constants';
import {
  EntryResultEnum,
  ProofResultEditedReasonEnum,
  ProofResultInsufficientReasonEnum
} from 'src/ts/enums';
import { IValueLabel } from 'src/ts/interfaces/valueLabel';

export const results: IValueLabel[] = [
  {
    value: EntryResultEnum.Clean,
    label: 'Clean'
  },
  {
    value: EntryResultEnum.Edited,
    label: 'Edited'
  },
  {
    value: EntryResultEnum.Undetermined,
    label: 'Insufficient'
  }
];

// TODO: The values should be handle by values and not by text sync with backend
export const reasons: IValueLabel[] = [
  {
    value: ProofResultInsufficientReasonEnum.SCANNED_DOCUMENTS,
    label: 'Scanned Documents'
  },
  {
    value: ProofResultInsufficientReasonEnum.PRINT_TO_PDF,
    label: 'Print to PDF Documents'
  },
  {
    value: ProofResultInsufficientReasonEnum.INVALID_DOCUMENT_TYPE,
    label: 'Invalid Document Type'
  },
  {
    value: ProofResultInsufficientReasonEnum.MERGED_DOCUMENT,
    label: 'Merged Document'
  },
  {
    value: ProofResultInsufficientReasonEnum.FOREIGN_ISSUED_DOCUMENT,
    label: 'Foreign Issued Document'
  },
  {
    value: ProofResultInsufficientReasonEnum.CROPPED_DOCUMENT,
    label: 'Cropped Document'
  },
  {
    value: ProofResultInsufficientReasonEnum.PENDING_EMPLOYER_VERIFICATION,
    label: 'Pending Employer Verification'
  },
  {
    value: ProofResultInsufficientReasonEnum.CUSTOM,
    label: 'Custom'
  }
];

const OLV_REASON_KEYS = [
  ProofResultInsufficientReasonEnum.MISSING_LETTERHEAD,
  ProofResultInsufficientReasonEnum.MISSING_WEBSITE,
  ProofResultInsufficientReasonEnum.CANNOT_FIND_BUSINESS_CONTACT_INFO,
  ProofResultInsufficientReasonEnum.MISSING_SALARY_HOURLY_RATE,
  ProofResultInsufficientReasonEnum.MISSING_START_DATE,
  ProofResultInsufficientReasonEnum.MISSING_TITLE,
  ProofResultInsufficientReasonEnum.MISSING_EMPLOYEE_NAME,
  ProofResultInsufficientReasonEnum.NAME_DOES_NOT_MATCH,
  ProofResultInsufficientReasonEnum.MISSING_COMPANY_NAME,
  ProofResultInsufficientReasonEnum.DATE_EXCEEDS_REASONABLE_WINDOW,
  ProofResultInsufficientReasonEnum.PENDING_EMPLOYER_VERIFICATION,
  ProofResultInsufficientReasonEnum.UNVERIFIED_INCOME,
  ProofResultInsufficientReasonEnum.NO_RESPONSE_NO_INCOME
] as const;

export const olvInsufficientReasons: IValueLabel[] = OLV_REASON_KEYS.map((value) => ({
  value,
  label: RESULT_INSUFFICIENT_REASON_LABEL[value]
}));

export const reasonsEdited: IValueLabel[] = [
  {
    value: ProofResultEditedReasonEnum.TEXT_INSERTION,
    label: 'Text Insertion'
  },
  {
    value: ProofResultEditedReasonEnum.FRAUDULENT_PDF_PRODUCER,
    label: 'Fraudulent PDF Producer'
  },
  {
    value: ProofResultEditedReasonEnum.FONT_FAIL,
    label: 'Font Fail'
  },
  {
    value: ProofResultEditedReasonEnum.CREATION_DATE,
    label: 'Creation Date'
  }
];

export const reasonsEditedExtended: IValueLabel[] = [
  {
    value: ProofResultEditedReasonEnum.TEXT_INSERTION,
    label: 'Text Insertion'
  },
  {
    value: ProofResultEditedReasonEnum.FRAUDULENT_PDF_PRODUCER,
    label: 'Fraudulent PDF Producer'
  },
  {
    value: ProofResultEditedReasonEnum.FONT_FAIL,
    label: 'Font Fail'
  },
  {
    value: ProofResultEditedReasonEnum.CREATION_DATE,
    label: 'Creation Date'
  },
  {
    value: ProofResultEditedReasonEnum.EASY_PAYROLL,
    label: 'Easy Payroll'
  },
  {
    value: ProofResultEditedReasonEnum.X_REF,
    label: 'X-Ref'
  },
  {
    value: ProofResultEditedReasonEnum.TEMPLATE,
    label: 'Template'
  },
  {
    value: ProofResultEditedReasonEnum.THREATLISTED_DOCUMENT,
    label: 'Threatlisted Document'
  },
  {
    value: ProofResultEditedReasonEnum.THREATLISTED_COMPANY,
    label: 'Threatlisted Company'
  },
  {
    value: ProofResultEditedReasonEnum.THREATLISTED_VISUAL_FEATURE,
    label: 'Threatlisted Visual Feature'
  },
  {
    value: ProofResultEditedReasonEnum.LINEARIZATION,
    label: 'Linearization'
  },
  {
    value: ProofResultEditedReasonEnum.ERROR_NOTIFICATION,
    label: 'Error Notification'
  },
  {
    value: ProofResultEditedReasonEnum.WARNING_NOTIFICATION,
    label: 'Warning Notification'
  },
  {
    value: ProofResultEditedReasonEnum.XMP,
    label: 'XMP'
  },
  {
    value: ProofResultEditedReasonEnum.BYTE_CODE,
    label: 'Byte Code'
  },
  {
    value: ProofResultEditedReasonEnum.OBJECT_NUMBERS,
    label: 'Object Numbers'
  },
  {
    value: ProofResultEditedReasonEnum.OTHER,
    label: 'Other'
  }
];
